<template>
  <v-app class="pa-6">
    <Header />
    <Sidebar />
    <v-main class="content" v-if="asyncDataStatus_ready">
      <BreadcrumbsProjeto />
      <router-view />
      <Footer />
    </v-main>
    <NotificationContainer></NotificationContainer>
  </v-app>
</template>
<script>

import Header from '@/pages/Projeto/components/Header/ProjetoHeader';
import Sidebar from '@/pages/Projeto/components/Sidebar/ProjetoSidebar';
import Footer from "@/components/Footer/Footer";
import BreadcrumbsProjeto from "@/components/Breadcrumbs/BreadcrumbsProjeto";
import NotificationContainer from '@/components/Notification/NotificationContainer'

import {mapActions} from "vuex";
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  name: 'ProjetoLayout',
  components: {Footer, Header, Sidebar, BreadcrumbsProjeto, NotificationContainer},
  mixins: [asyncDataStatus],
  methods: {
    ...mapActions('projeto', ['fetchProjeto', 'getIndicadoresByProjetoId']),
    ...mapActions('logicaIntervencao', ['fetchLogicaIntervencoes']),
    ...mapActions('resumoProjeto', ['calcularResumo']),
  },
  created () {
    this.fetchProjeto(this.$route.params.projetoId)
      .then(() => this.getIndicadoresByProjetoId(this.$route.params.projetoId))
      .then(() => this.fetchLogicaIntervencoes(this.$route.params.projetoId))
      //.then(() => this.calcularResumo(this.$route.params.projetoId))
      .then(() => { this.asyncDataStatus_fetched() })
  }
};
</script>

<style src="./ProjetoLayout.scss" lang="scss" />
